import React, { Component } from 'react';
import AuthService from '../../utils/AuthService';
import Page from '../Page';
import PageSection from '../PageSection';
import UserForm from '../UserForm';
import Input from '../Input';
import Popup from '../Popup';

const validationObject = [
	{
		"fieldName": "first_name",
		"required": true,
		"errorMessage": "First name"
	},
	{
		"fieldName": "last_name",
		"required": true,
		"errorMessage": "Last name"
	},
	{
		"fieldName": "company",
		"required": true,
		"errorMessage": "Company name"
	},
	{
		"fieldName": "pp_user_email",
		"required": true,
		"errorMessage": "Email address"
	},
	{
		"fieldName": "phone",
		"required": false,
		"errorMessage": "Phone number"
	},
	{
		"fieldName": "website",
		"required": false,
		"errorMessage": "Website"
	},
	{
		"fieldName": "password",
		"required": true,
		"errorMessage": "Password"
	}
];

class Register extends Component {
	constructor(props) {
		super(props);

		this.Auth = new AuthService();
		this.state = {
			user: {},
			errors: []
		};

		this.validationObject = validationObject;
		this.sectionActions = <a href="/login" className="pp-text-button">Login</a>;
		this.onChange = this.onChange.bind(this);
		this.submitUserForm = this.submitUserForm.bind(this);

		this.showMessage = this.showMessage.bind(this);
		this.hideMessage = this.hideMessage.bind(this);
		this.loadingButton = this.loadingButton.bind(this);
		this.removeLoadingButton = this.removeLoadingButton.bind(this);
		this.validateForm = this.validateForm.bind(this);
	}

	onChange(e) {
		this.setState({
			user: {
				...this.state.user,
				[e.target.name]: e.target.value
			}
		});
	}

	submitUserForm(e) {
		let formData = new FormData();
		const { user } = this.state;
		var target = e.target;

		formData.append("user", JSON.stringify(user));

		// TODO: check that all fields are valid or required as needed
		if(this.validateForm()) {
			this.loadingButton(target);
			// update the user
			this.Auth.post('/pp-users/register', formData)
			.then(
				(result) => {
					console.log(result);
					this.removeLoadingButton(target);
					if(result.success) {
						this.showMessage('You will be notified by email when your application has been approved.', 'Thank You for Registering', <a href="/login" className="pp-button">Done</a>);
					} else {
						if(result.messages) {
							this.showMessage(result.messages.join("\n"));
						}
					}
				},
				(error) => {
					this.removeLoadingButton(target);
					this.showMessage('Something went wrong. Please try again later.');
					this.setState({
						error
					});
				}
			);
		}
	}

	validateForm() {
		let validCount = this.validationObject.length;
		let errors = [];
		let stateErrors = {};
		let hasErrors = false;

		for(let i=0; i<validCount; i++) {
			if(this.validationObject[i].required) {
				if( !this.state.user[this.validationObject[i].fieldName]) {
					let message = this.validationObject[i].errorMessage;
					errors.push(<p>{message}</p>);
					stateErrors[this.validationObject[i].fieldName] = true;
					hasErrors = true;
				}
			}
		}

		if(hasErrors) {
			this.showMessage(errors, "Please complete these required fields");
			this.setState({
				errors: stateErrors
			});
		}

		return !hasErrors;
	}

	showMessage(body, title, actionButtons) {
		var messageTitle = title || ' ',
			messageActionButtons = actionButtons || <button className="pp-button" onClick={this.hideMessage}>Close</button>;

		this.setState({
			message: {
				body: body,
				title: messageTitle,
				actionButtons: messageActionButtons
			}
		});
	}

	hideMessage() {
		this.setState({
			message: false
		});
	}

	loadingButton(target) {
		target.disabled = true;
		target.classList.add('pp-loading');
	}

	removeLoadingButton(target) {
		target.disabled = false;
		target.classList.remove('pp-loading');
	}

	render() {
		const { user,
		 		message
				} = this.state;

		return (
			<Page pageClass="pp-register-page">

				{message &&
					<Popup body={message.body} title={message.title} actionButtons={message.actionButtons} />
				}

				<PageSection sectionTitle="Register">

					<UserForm
						user={user}
						onChange={this.onChange}
						errors={this.state.errors}
					/>

					<div class="pp-form-wrapper">
						<Input
							type="password"
							label="Password"
							htmlName="password"
							placeholderText="Password"
							value={user.password}
							onChange={this.onChange}
							error={this.state.errors.password || false}
						/>
					</div>

					<div className="pp-action-buttons">
						<button className="pp-button" onClick={this.submitUserForm}>Register</button>
					</div>

				</PageSection>

			</Page>
		);
	}
}

export default Register;



// WEBPACK FOOTER //
// ./src/components/pages/Register.js